export enum AssetRecoveryStatus {
  Paid = 'Paid',
  Unpaid = 'Unpaid',
}

export type AssetRecoveryCase = {
  case_id: string;
  case_index: number;
  incidents: AssetRecoveryIncident[];
};

export type AssetRecoveryIncident = {
  asset_recovery_id: string | null;
  review_outcome_id: string;
  review_id: string;
  incident_date: string | null;
  amount: number;
  status: AssetRecoveryStatus | null;
  is_shared: boolean;
};

export type CreateAssetRecoveryReportRequest = {
  review_outcome_ids: string[];
  title: string;
};

export type CreateAssetRecoveryReportResponse = {
  id: string;
};

export type AssetRecoverySummaryReport = {
  asset_recovery_id: string;
  status: AssetRecoveryStatus;
  amount: number;
  added_fees: number;
  created_at: string;
  incident_count: number;
};

export type AssetRecoveryReport = {
  id: string;
  title: string;
  created_by: string | null;
  created_at: string;
  is_shared: boolean;
  branch_id: number;
  location_id: number;
  location_name: string;
  amount: number;
  added_fees: number;
  payment_url: string;
  incidents: AssetRecoveryReportIncident[];
};

export type AssetRecoveryReportIncident = {
  case_index: number;
  review_id: string;
  incident_date: string | null;
};
